import styled from 'styled-components';

import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[12]};

  .spacer {
    width: 1px;
    height: 16px;
    background-color: ${color.green[200]};
  }
`;

export const Filter = styled.div`
  position: relative;
`;

export const FilterBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${spacing[8]};
  padding: ${spacing[4]} ${spacing[8]};
  border-radius: ${spacing[8]};
  border-color: ${color.common.transparent};
  background-color: ${color.common.transparent};
  ${font('text', 'lg', '700')}
  color: ${color.darkBlue[1000]};

  use,
  svg {
    pointer-events: none;
  }

  &:hover {
    outline: none;
    box-shadow: 0px 0px 0px 4px #bbe2ff, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  }

  ${({ isHovered }) =>
    isHovered &&
    `
    outline: none;
    box-shadow: 0px 0px 0px 4px #BBE2FF, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  `}
`;

export const FilterDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  max-width: max-content;
  max-height: 270px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing[8]};
  padding: ${spacing[16]} ${spacing[0]};
  border-radius: ${spacing[8]};
  border: 1px solid ${color.darkBlue[50]};
  background-color: ${color.common.white};
  box-shadow: 0px 24px 48px -12px rgba(16, 24, 40, 0.18);
  z-index: 10;
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: ${spacing[8]};
  }

  &::-webkit-scrollbar-track {
    background: ${color.grey[200]};
    border-top-right-radius: ${spacing[8]};
    border-bottom-right-radius: ${spacing[8]};
  }

  &::-webkit-scrollbar-thumb {
    background: ${color.blue[700]};
    border-radius: ${spacing[8]};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const FilterDropdownWrapper = styled.div`
  width: 100%;
  max-width: 370px;

  display: flex;
  flex-direction: column;
  gap: ${spacing[8]};
  padding: ${spacing[0]} ${spacing[24]};
`;

export const ClearBtn = styled.button`
  display: flex;
  align-items: center;
  gap: ${spacing[8]};

  padding: ${spacing[0]} ${spacing[12]};

  background-color: ${color.common.transparent};
  border-color: ${color.common.transparent};
  outline: none;
  ${font('text', 'lg', '700')}
  color: ${color.darkBlue[400]};
`;

export const OrderButton = styled.button`
  width: 100%;
  min-width: 240px;
  max-width: max-content;
  display: flex;
  align-items: center;
  padding: ${spacing[4]} ${spacing[8]};
  background-color: ${color.common.transparent};
  border-color: ${color.common.transparent};
  outline: none;
  border-radius: ${spacing[8]};
  ${font('text', 'md', '400')}
  text-align: left;

  color: ${color.darkBlue[1000]};
  ${props => props.active && `background: ${color.darkBlue[25]};`}
  &:hover {
    background: ${color.darkBlue[25]};
  }
`;
